import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import Utils from "../shared/utilerias/utils";

@Injectable({
  providedIn: 'root'
})
export class execDbService {
  private apiUrl = Utils.getBaseUrlApiWeb() + '/execDb/execDb';

  constructor(private http: HttpClient) { }

  processJsonData(jsonData: any): Observable<any> {
    return this.http.post(this.apiUrl, jsonData).pipe(
      map((res: any) => {
        if (res.error) {throw new Error(res.message);}
        return res;
      })
    );
  }
}